export const Collections = {
  USER: 'users',
  GAME: 'games',
  PRICE: 'eth-usd-price',
};
